import styled from 'styled-components';

export const Hover = styled.div`
  transition: box-shadow 0.2s ease-in-out;
  :hover {
    box-shadow: 0px 2px 10px rgba(110, 110, 110, 0.25);
  }
`;
